import * as React from "react";
import { IconProps } from "../types";

const CheckboxIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        width="18"
        height="19"
        viewBox="0 0 18 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
        {...props}
      >
        <path
          d="M9 16.75C13.0041 16.75 16.25 13.5041 16.25 9.5C16.25 5.49594 13.0041 2.25 9 2.25C4.99594 2.25 1.75 5.49594 1.75 9.5C1.75 13.5041 4.99594 16.75 9 16.75Z"
          fill={color}
          fill-opacity="0.15"
        />
        <path
          d="M9 16.75C13.0041 16.75 16.25 13.5041 16.25 9.5C16.25 5.49594 13.0041 2.25 9 2.25C4.99594 2.25 1.75 5.49594 1.75 9.5C1.75 13.5041 4.99594 16.75 9 16.75Z"
          stroke={color}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M5.5 9.50006C6.363 10.3671 7.037 11.3681 7.6 12.4621C8.907 9.97106 10.54 7.99606 12.5 6.53906"
          stroke={color}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    );
  },
);

export default CheckboxIcon;
